var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.containsFornecedor || _vm.showNaoHomologado)
&& _vm.hasAnyFornecedoresProdutosHomologado)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({class:_vm.iconClass,attrs:{"small":_vm.small,"size":_vm.iconSize,"color":_vm.color}},on),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}],null,false,2706689688)},[_c('span',[_vm._v(_vm._s(_vm.tooltip))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }